import { render, staticRenderFns } from "./LoginInfoBar.vue?vue&type=template&id=367316cc&scoped=true"
import script from "./LoginInfoBar.vue?vue&type=script&lang=ts"
export * from "./LoginInfoBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367316cc",
  null
  
)

export default component.exports